import {useEffect} from "react";

export default function useSetTitle(title) {
   let newTitle = title ? `${title} - Domecq Academy` : "Domecq Academy";
   useEffect(() => {
      document.title = newTitle;
      return () => {
         document.title = "Domecq Academy";
      };
   }, [newTitle]);

   return true;
}
